import { createContext } from "react";

export const IsDoneContext = createContext({});